import { ChevronDown, Layers3 } from 'lucide-react';
import { LAYER_GROUPS, type BaseMap, type LayerId } from './atlasModel';
export function AtlasLayers({
  layers,
  basemap,
  onLayer,
  onBasemap,
  onPreset,
  onSources,
}: {
  layers: LayerId[];
  basemap: BaseMap;
  onLayer: (id: LayerId) => void;
  onBasemap: (value: BaseMap) => void;
  onPreset: (value: string) => void;
  onSources: () => void;
}) {
  return (
    <aside className="atlas-layers" aria-label="Map layers">
      <div className="atlas-panel-heading">
        <h2>
          <Layers3 size={15} />
          Layers
        </h2>
        <select
          aria-label="Map preset"
          defaultValue=""
          onChange={(e) => {
            onPreset(e.target.value);
            e.target.value = '';
          }}
        >
          <option value="" disabled>
            Presets
          </option>
          <option value="owner">Owner overview</option>
          <option value="delivery">Active delivery</option>
          <option value="pipeline">Bid pipeline</option>
          <option value="history">Track record</option>
          <option value="site">Site diligence</option>
        </select>
      </div>
      <div className="atlas-layer-scroll">
        {LAYER_GROUPS.map((group) => (
          <details key={group.title} open className="atlas-layer-group">
            <summary>
              {group.title}
              <ChevronDown size={12} />
            </summary>
            {group.items.map((layer) => (
              <label key={layer.id} title={layer.detail} className="atlas-layer-toggle">
                <input
                  type="checkbox"
                  checked={layers.includes(layer.id)}
                  onChange={() => onLayer(layer.id)}
                />
                <span>{layer.label}</span>
                <span
                  className={'atlas-switch ' + (layers.includes(layer.id) ? 'is-on' : '')}
                  aria-hidden="true"
                />
              </label>
            ))}
          </details>
        ))}
        <button type="button" className="atlas-text-button" onClick={onSources}>
          Sources & coverage →
        </button>
      </div>
      <div className="atlas-basemaps">
        <p>Map appearance</p>
        <div>
          {(['dark', 'satellite', 'terrain', 'street'] as const).map((value) => (
            <button
              type="button"
              key={value}
              onClick={() => onBasemap(value)}
              aria-pressed={basemap === value}
            >
              <span className={'atlas-basemap-preview atlas-basemap-preview--' + value} />
              <span>{value}</span>
            </button>
          ))}
        </div>
      </div>
    </aside>
  );
}
